import { Avatar } from "@mui/material";
import { toast } from "react-toastify";
import { navigateWithReload } from "../../utils/helpers";

export default function NotificationToast({ avatar, sender, title, message, time, url }) {
  function stringToColor(string) {
    let hash = 0;
    let i;

    /* eslint-disable no-bitwise */
    for (i = 0; i < string?.length; i += 1) {
      hash = string?.charCodeAt(i) + ((hash << 5) - hash);
    }

    let color = "#";

    for (i = 0; i < 3; i += 1) {
      const value = (hash >> (i * 8)) & 0xff;
      color += `00${value?.toString(16)}`?.slice(-2);
    }
    /* eslint-enable no-bitwise */

    return color;
  }
  function stringAvatar(name) {
    return {
      sx: {
        bgcolor: stringToColor(name),
      },
      children: `${name?.split(" ")[0][0]}${name?.split(" ")[1][0]}`,
    };
  }

  const handleClick = () => {
    if (url) {
      toast.dismiss();
      // A full reload, not a client-side navigate: the user is often already on
      // the page the notification is about, where navigating alone would leave
      // the change just announced off the screen.
      navigateWithReload(url);
    }
  };

  return (
    <div
      className={`flex items-start gap-3 p-3 bg-white rounded-xl shadow-lg w-full max-w-[320px] sm:max-w-[360px] ${url ? "cursor-pointer hover:bg-gray-50 transition-colors" : ""}`}
      onClick={handleClick}
    >
      <Avatar
        src={avatar}
        alt={sender || "User"}
        {...(!avatar && stringAvatar ? stringAvatar(sender) : {})}
      />

      <div className="flex flex-col flex-1">
        <div className="flex justify-between items-center">
          {title && (
            <span
              className="text-sm text-gray-900 mt-0.5 break-words"
              dangerouslySetInnerHTML={{ __html: title }}
            ></span>
          )}

          {/* {time && <span className="text-[11px] text-gray-400 w-[50x]">{time}</span>} */}
        </div>

        {message && (
          <p
            className="text-sm text-gray-600 mt-0.5 line-clamp-2"
            dangerouslySetInnerHTML={{ __html: message }}
          ></p>
        )}
      </div>
    </div>
  );
}
